import React, { useEffect, useState } from 'react';

const AccordionContent = (props) => {
let accordionClasses = '';
    props.classList == undefined ? accordionClasses = '' : accordionClasses = props.classList;

    let classes = 'accordionContentContainer ' + accordionClasses;

    // let classes = handleAccState;

    {}
    // props.clickFunction == undefined ? callBackFunc = e => {} : callBackFunc = () => props.clickFunction(data);

    return(
        <>
            <div className={classes} id={props.id} onClick={props.handleAccState}>{props.children}</div>
        </>
    )
   
} 

// props.handleAccordionExpand
export default AccordionContent;